/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type BuildingTypeEnum = (typeof BuildingTypeEnum)[keyof typeof BuildingTypeEnum];

export const BuildingTypeEnum = {
  hs: 'hs',
  apt: 'apt',
  farm: 'farm',
} as const;
